/// <reference path='../../docs-and-forms.module.ts' />
/// <reference path='../../../../../../typings/index.d.ts' />
///<reference path="../../docs-and-forms.models.ts"/>
///<reference path="../../docs-and-forms-render.service.ts"/>

module Meevo.Plugins.DocsAndForms {

    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;

    class MarkupUdfComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            'meevo.components.common.DataService',
            '$q',
        ];


        model: ng.INgModelController;
        udf: IUserDefinedControl;

        modelObj: { fileGuid: string; };

        get storageTypeEnum() {
            return StorageTypeEnum;
        }

        constructor(protected $scope: ng.IScope,
                    private dataService: Meevo.Components.BaseClasses.IDataService,
                    private $q: ng.IQService) {
        }

        public getImageUrl(storageTypeEnum: StorageTypeEnum, fileGuid: Guid | string): angular.IPromise<Meevo.Model.IStorageFile> {
            if (!fileGuid) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData(`/api/storage/customBrandingImage/${storageTypeEnum}/${fileGuid}`, 'GET', null);
        }

        $onInit(): void {
            this.modelObj = this.model.$viewValue;

            this.$scope.$watch(() => this.modelObj, () => {
                this.udf.fileGuid = this.modelObj.fileGuid;
                this.model.$setViewValue(this.modelObj);
            }, true);

            const valueWatcher = this.$scope.$watch(() => this.model.$viewValue, () => {
                if (!this.modelObj && this.model.$viewValue) {
                    this.modelObj = this.model.$viewValue;
                    valueWatcher();
                }
            });

            this.model.$validators.required = (modelValue: Meevo.Model.IStorageFile) => {
                return !!modelValue.fileGuid;
            };
        }

        $onDestroy() {
            this.model.$validators.required = null;
        }

        public bindCustomBrandingImage(imageData: IStorageFile, url: any): any {
            if (imageData) {
                url = this.searchFile(imageData, 'Source', url);
            }
            return url;
        }

        searchFile(filedata: IStorageFile, searchKey: string, defaultUrl: string): string {
            let filedetails = undefined;
            let fileUrl = defaultUrl;
            if (filedata) {
                filedetails = filedata;
            }

            if (filedetails
                && filedetails.meevoFile
                && filedetails.meevoFile.files
                && filedetails.meevoFile.files.length > 0) {

                filedetails.meevoFile.files.forEach(function (setting) {
                    if (setting.key === searchKey) {
                        fileUrl = setting.fileUrl;
                    }
                });
            }
            return fileUrl;
        }

    }


    angular.module('meevo.plugins.docsAndForms')
        .component('markupUdfComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/docsAndForms/components/markup-udf/markup-udf.component.html',
            controller: MarkupUdfComponent,
            controllerAs: '$ctrl',
            require: {
                model: 'ngModel'
            },
            bindings: {
                udf: '=',
            }
        });
}
